var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.9706H21M12.75 8.5H17.25M13.5 19.2059V14.2647M16.5 19.2059V14.2647M17.625 22.5H12.375C11.5466 22.5 10.875 21.7626 10.875 20.8529L10.5326 11.8284C10.5148 11.3605 10.8554 10.9706 11.2819 10.9706H18.7181C19.1446 10.9706 19.4852 11.3605 19.4674 11.8284L19.125 20.8529C19.125 21.7626 18.4534 22.5 17.625 22.5Z",
    stroke: "#898E99",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.faceb60d3c5e64fdc7a742f6576de788.svg";
export { ForwardRef as ReactComponent };